import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const PosCell = ({ raceOutcomeCode, noOfRunners, disqualificationDesc }) => (
    <span>
        <strong>
            {_.toLower(disqualificationDesc) === 'disq' ?
                'd' : raceOutcomeCode.trim()}
        </strong>
        /{noOfRunners}
    </span>
);

PosCell.propTypes = {
    raceOutcomeCode: PropTypes.string,
    noOfRunners: PropTypes.number,
    disqualificationDesc: PropTypes.string,
};

export default PosCell;



// WEBPACK FOOTER //
// ./src/js/human/form/components/PosCell.jsx